<form #form="ngForm"
      novalidate
      [afterContentInit]="registerForm.bind(this, form)">
  @if (personType() === PAYMENT_PERSON_TYPES.COMPANY) {
    <div class="form-group">
      @if (!useCompanySearcher()) {
        <label class="fw-bold label-xl-to-md">{{ 'common.companyName' | translate }}</label>
        <input class="form-control"
               name="company_name"
               [(ngModel)]="info.userCompanyName"
               [maxlength]="64"
               placeholder="{{'common.companyName' | translate}}..."
               required>
      }

      @if (useCompanySearcher() && (!info.userCompanyName || lookingForAnotherCompany)) {
        <company-searcher
          class="d-block"
          [bakeryId]="bakeryId()"
          [countryCode]="countryCode()"
          [allowEhk]="true"
          [selectedItem]="{'name': info.userCompanyName}"
          [showCancel]="lookingForAnotherCompany"
          [showCompanySearcherLabel]="false"
          [allowToChangeCompany]="allowToEditCompany()"
          (onCancel)="cancelCompanyChange()"
          (onCompanyFound)="companySelected($event)"
        ></company-searcher>
      }

      @if (useCompanySearcher() && info.userCompanyName && !lookingForAnotherCompany) {
        <label class="fw-bold label-xl-to-md">{{ 'common.companyName' | translate }}</label>

        <div class="org-name-org-number">
          <input class="form-control"
                 type="text"
                 disabled
                 [value]="info.userCompanyName" />

          <div class="invoice-info-org-number font-md">
            {{ info.invoiceCompanyOrgNumber }}
          </div>
        </div>

        <div class="text-end">
          <button type="button" class="btn btn-link pt-1 pe-0"
                  [disabled]="!allowToEditCompany()"
                  (click)="changeCompany()">
            {{ 'orderProcess.payment.userInvoiceInfo.changeCompany' | translate }}
          </button>
        </div>
      }
    </div>
  }

  @if (askUserName()) {
    <div class="form-group">
      <label class="fw-bold label-xl-to-md">{{ 'common.name' | translate }}</label>
      <input class="form-control"
             name="full_name"
             [(ngModel)]="info.userName"
             [maxlength]="120"
             placeholder="{{'orderProcess.payment.contactForm.yourName' | translate}}..."
             required>
    </div>
  }

  @if (askEmail()) {
    <div class="form-group">
      <label class="fw-bold label-xl-to-md">{{ 'common.emailAddress' | translate }}</label>
      <input class="form-control"
             name="email"
             [(ngModel)]="info.userEmail"
             [maxlength]="128"
             [pattern]="EMAIL_PATTERN"
             [placeholder]="('orderProcess.payment.contactForm.yourEmail' | translate) + '...'"
             required />

      <ui-email-misspelled
        class="d-block mt-1"
        [email]="info.userEmail"
      ></ui-email-misspelled>

      <div class="mt-2 subscribe-on-news">
        <ui-checkbox
          [model]="info?.subscribedOnNews"
          (modelChange)="info.subscribedOnNews = $event; emitStatus({ subscribedOnNews: $event })">
          {{ 'auth.subscribeOnNews' | translate }}
        </ui-checkbox>
      </div>
    </div>
  }

  @if (askPhone()) {
    <div class="row">
      <div class="col-lg-8">
        <ui-i18n-phone-input
          *libphonenumber
          maxlength="32"
          name="phone"
          [required]="true"
          [defaultCountryCode]="countryCode()"
          [placeholder]="('orderProcess.payment.contactForm.yourMobile' | translate) + '...'"
          [(ngModel)]="info.userPhone"
        ></ui-i18n-phone-input>

        @if (showSmsInfo()) {
          <small class="d-block text-muted phone-number-note"
                 [translate]="'orderProcess.payment.phoneNumberNote'">
            We will send your order confirmation per sms (free)
          </small>
        }
      </div>
    </div>
  }

  @if (askForReferenceField()) {
    <div class="form-group mt-3 position-relative">
      <label class="label-xl-to-md fw-bold">
        {{ 'orderProcess.payment.reference.title' | translate }}
        <small class="fw-normal">({{ 'common.optional' | translate }})</small>
      </label>

      <ui-input-with-tooltip
        [tooltipText]="'orderProcess.payment.reference.tooltipText' | translate">
        <input class="form-control position-relative"
               [name]="'reference'"
               [maxlength]="128"
               [placeholder]="'orderProcess.payment.reference.placeholder' | translate"
               [(ngModel)]="info.reference" />
      </ui-input-with-tooltip>
    </div>
  }
</form>
